import React from "react";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";

type IProps = {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  onCloseClick?: (open: boolean) => void;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "full" | "45";
  dialogData: {
    title?: string;
    description?: string;
    body: React.ReactNode;
    footer?: React.ReactNode;
    trigger?: React.ReactNode;
  };
  styles?: {
    dialogContent?: string;
    dialogHeader?: string;
    dialogTitle?: string;
    dialogBody?: string;
    dialogFooter?: string;
  };
  direction?: "right" | "left" | "top" | "bottom";
};

export const Modal = ({ open, onOpenChange, size = "sm", dialogData, styles }: IProps) => {
  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "max-w-[300px] xs:max-w-sm";
      case "md":
        return "max-w-[300px] xs:max-w-md";
      case "lg":
        return "max-w-[300px] xs:max-w-lg";
      case "xl":
        return "max-w-[300px] xs:max-w-xl";
      case "2xl":
        return "max-w-[300px] xs:max-w-2xl";
      case "45":
        return "max-w-[300px] xs:max-w-[45%]";
      case "full":
        return "max-w-[300px] xs:max-w-full";
      default:
        return "max-w-[300px] xs:max-w-lg";
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        tabIndex={-1} // 👈 makes it programmatically focusable
        className={`${getSizeClass()} ${styles?.dialogContent || "p-0! rounded-sm"}`}
      >
        {dialogData.title && (
          <DialogHeader className={styles?.dialogHeader || "bg-muted p-4 rounded-t"}>
            <DialogTitle className={styles?.dialogTitle}>{dialogData.title}</DialogTitle>
            {dialogData.description && <DialogDescription>{dialogData.description}</DialogDescription>}
          </DialogHeader>
        )}
        <div className={`px-4 py-2 max-h-[60vh] overflow-y-auto scrollbar-thin ${styles?.dialogBody || ""}`}>{dialogData.body}</div>
        {dialogData.footer && <div className={`p-4 ${styles?.dialogFooter || ""}`}>{dialogData.footer}</div>}
      </DialogContent>
    </Dialog>
  );
};
